// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"b4238517","409":"7dab3e0a","565":"8da1dc22","716":"fa81a17f","796":"35f2dfbf","942":"defa8d57","955":"08e952bb"}[chunkId] + ".chunk.js";
};